<div class="row align-items-center p-b-10 d-none">
  <div class="col-sm-12 col-lg-12">
    <div class="d-flex align-items-center flexmob">
      <div class="m-l-10 d-flex align-items-center">
        <div class="m-l-10">
          <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
            Trustees' Report
          </h4>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row align-items-center m-b-10">
  <div class="col-sm-12 col-lg-6">
    <div class="d-flex align-items-center flexmob">
      <div class="d-flex align-items-center f-s-14 text-black-25 border-right p-r-10 cursor-pointer f-w-600" (click)="backToCharityOverView()">
        <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-left"></i-tabler> Back to Charity Overview
      </div>
      <div class="m-l-10 d-flex align-items-center">
        <div class="m-l-10">
          <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
            Trustees' Report
          </h4>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-lg-6  text-end">
    <div class="d-flex align-items-center justify-content-end">
    </div>
  </div>
</div>
<!--Period Finalised & Ready to Submit-->
<ng-template #otherUI>
  <div *ngIf="apFinalised " class="col-md-12 col-lg-12 m-t-20 p-0">
    <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #fed7aa !important; background: #fff7ed; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
      <mat-card-content class="p-y-20">
        <div class="row align-items-center">
          <div class="col-md-8">
            <div class="d-flex align-items-center">
              <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #ff9f1f; background: #ffedd5; display: flex; align-items: center; justify-content: center;" class="text-warning">
                <i-tabler name="lock" class="icon-24" style="color: #ea580c;"></i-tabler>
              </div>

              <div class="m-l-10">
                <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                  Period Finalised & Ready to Submit
                </h4>
                <div>
                  <h5 class="f-s-14 f-w-600 m-x-4">Accounts have been finalised and are now ready to submit  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-right lockUnlockRes">
            <div class="d-flex gap-10 justify-content-end custom-cards-trial">
              <button mat-flat-button class="rounded-5" style="border: 1px solid #fdba74; background:#fff;" (click)="UnfreezeAP()">
                <div class="d-flex text-black">
                  <i-tabler class="icon-20 m-r-4 m-t-0" name="lock-open" style="color: #c2410c;"></i-tabler><span class="f-s-14" style="color: #c2410c;">Unlock</span>
                </div>
              </button>
              <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="gotoSubmissions()">
                <div class="d-flex text-black">
                  <!--<i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler>--><span class="f-s-14 text-white">Submit</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>
<!--Period Finalised & Ready to Submit ends-->
<!--Period Submitted-->
<div *ngIf="apFinalised &&  this.UserRoleAccess?.currentAPSubmitStatus != 'Not Submit' && this.UserRoleAccess?.currentAPSubmitStatus  !== 'Failed' ; else otherUI" class="col-md-12 col-lg-12 p-0 m-t-20">
  <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #A7F3D0 !important; background: #ECFDF5; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
    <mat-card-content class="p-y-20">
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="d-flex align-items-center">
            <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #9ee9c2; background: #d1fae5; display: flex; align-items: center; justify-content: center; " class="text-warning">
              <i-tabler name="circle-check" class="icon-30" style="color: #059669;"></i-tabler>
            </div>
            <div class="m-l-10">
              <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                Period Submitted
              </h4>
              <div>
                <h5 class="f-s-14 f-w-600 m-x-4">Submitted to Companies House on {{this.UserRoleAccess?.currentAPSubmitDate}}</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 text-right lockUnlockRes">
          <div class="d-flex gap-10 justify-content-end custom-cards-trial">
            <button mat-flat-button class="rounded-5 successBtn" (click)="UnlockandAmend()">
              <div class="d-flex">
                <i-tabler class="icon-20 m-r-4 m-t-0" name="reload"></i-tabler><span class="f-s-14">Unlock & Amend Accounts</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
<!--Ends Period Submitted-->
<div class="">
  <div class="row">
    <div class="col-md-4" (click)="showTrusteeRepport()">
      <div class="card-holder tab-title1" [ngClass]="trusteeReport ? 'active' : ''">
        Trustees' Annual Report
      </div>
    </div>
    <div class="col-md-4" (click)="canOpenStatementOfRes() && showStatementofRes()">
      <div class="card-holder tab-title2" [ngClass]="(StatementofRes == true) ? 'active' : ''">
        Statement of Trustees' Responsibility
      </div>
    </div>
    <div class="col-md-4" (click)="canOpenDeclaration() && showDeclaration()">
      <div class="card-holder tab-title" [ngClass]="(declaration == true) ? 'active' : ''">
        Trustees' Declaration
      </div>
    </div>
  </div>
</div>
<div class="m-t-12 trusteeReport" *ngIf="trusteeReport">
  <div class="col-12 p-0">
    <div class="col-sm-12 col-sm-12 bg-white border-radius10 m-b-10 p-10 p-x-16">
      <div class="d-flex justify-content-between align-items-center">
        <div class="label">
          <p class="f-s-14 m-b-10 m-t-6">The TAR provides stakeholders with important information about your charity activities, achievements, and governance.</p>
          <h4 class="f-s-14">Do you want to include Trustee Annual Report in your Accounts?</h4>
        </div>
        <div class="radio-selection">
          <mat-radio-group aria-label="Select an option" [disabled]="apFinalised||this.ReportType_Method == 'Auditor' || jurisdiction_Charity == 'northern_ireland'" (change)="setVisibility($event)" [(ngModel)]="tarDetails.annualReport_Status">
            <mat-radio-button value='Yes' [checked]="showContent">Yes</mat-radio-button>
            <mat-radio-button value='No' [checked]="!showContent">No</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="tarDetails.annualReport_Status=='Yes'">
    <mat-card class="m-t-0">
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
        <mat-tab label="Section A">
          <ng-template matTabContent>
            <div class="p-16 b-b-1 justify-content-center align-items-center" style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
              <mat-card-title class="p-x-0 mat-mdc-card-title">
                <h4 class="f-s-26 f-w-700 text-center" style=" background: #10756e; padding: 10px; color: #fff;"> Reference and Administration Details</h4>
              </mat-card-title>
              <mat-card-content class="b-1 m-t-12 p-x-0">
                <fieldset [disabled]="apFinalised">
                  <mat-card-title class="p-x-14 b-b-1 mat-mdc-card-title">
                    <div class="d-flex align-items-center p-y-20">
                      <div class="">
                        <h4 class="f-s-16 primary-color-dark f-w-600 d-block">Charity Information</h4>
                      </div>
                    </div>
                  </mat-card-title>
                  <div class="p-x-14 m-y-10 m-t-20 row">
                    <div class="col-lg-6">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Charity name</mat-label>
                    </div>
                    <div class="col-lg-6">
                      <mat-form-field appearance="outline" class="w-100 m-b-2">
                        <input matInput name="charity_Name" [(ngModel)]="charityInformation.charity_Name" title="{{charityInformation.charity_Name}}" disabled />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="p-x-14 m-y-10 row">
                    <div class="col-lg-6">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Other name the charity is known by</mat-label>
                    </div>
                    <div class="col-lg-6">
                      <mat-form-field appearance="outline" class="w-100 m-b-2">
                        <input matInput name="other_Names" [(ngModel)]="charityInformation.other_Names" (input)="dirty()" title="{{charityInformation.other_Names}}" placeholder="Other name" [disabled]="charityInformation.from_CharityCommission =='yes'" />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="p-x-14 m-y-10 row">
                    <div class="col-lg-6">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block">
                        Registered charity number
                      </mat-label>
                    </div>
                    <div class="col-lg-6">
                      <mat-form-field appearance="outline" class="w-100 m-b-2">
                        <input matInput name="charity_Registration_Number" [(ngModel)]="charityInformation.charity_Registration_Number" disabled placeholder="Charity Registration Number " />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="p-x-14 m-y-10 row">
                    <div class="col-lg-6">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block">
                        Company registration number
                      </mat-label>
                    </div>
                    <div class="col-lg-6">
                      <mat-form-field appearance="outline" class="w-100 m-b-2">
                        <input matInput name="company_Reference_Number" [(ngModel)]="charityInformation.company_Reference_Number" disabled placeholder="Company Reference Number" />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="p-x-14 m-y-10 row">
                    <div class="col-lg-6">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block">
                        Charity's principal address
                      </mat-label>
                    </div>
                    <div class="col-lg-6">
                      <mat-form-field appearance="outline" class="w-100 m-b-10">
                        <input matInput name="addressLine1" [(ngModel)]="charityInformation.addressLine1" disabled placeholder="Address Line 1" />
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="w-100 m-b-10">
                        <input matInput name="addressLine2" [(ngModel)]="charityInformation.addressLine2" disabled placeholder="Address Line 2" />
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="w-100 m-b-10">
                        <input matInput name="addressLine3" [(ngModel)]="charityInformation.addressLine3" disabled placeholder="Address Line 3" />
                      </mat-form-field>
                      <div class="row">
                        <div class="col-lg-6">
                          <mat-form-field appearance="outline" class="w-100">
                            <input matInput name="city" [(ngModel)]="charityInformation.city" disabled placeholder="City" />
                          </mat-form-field>
                        </div>
                        <div class="col-lg-6">
                          <mat-form-field appearance="outline" class="w-100">
                            <input matInput name="postcode" [(ngModel)]="charityInformation.postcode" disabled placeholder="Postcode" />
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </mat-card-content>
              <mat-card-content class="b-1 m-t-12 p-x-0">
                <mat-card-title class="p-x-14 b-b-1 mat-mdc-card-title">
                  <div class="d-flex align-items-center p-y-20">
                    <div class="">
                      <h4 class="f-s-16 primary-color-dark f-w-600 d-block">
                        Names of the charity trustees who manage the charity
                      </h4>
                    </div>
                  </div>
                </mat-card-title>
                <div class="p-x-14 m-y-10 row">
                  <div class="table-responsive w-100 m-14" style="border-radius: 6px;">
                    <fieldset [disabled]="apFinalised">
                      <table mat-table [dataSource]="trustees" class="w-100">
                        <ng-container matColumnDef="Trustee Name">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">Trustee Name</th>
                          <td mat-cell *matCellDef="let trustees">
                            <mat-form-field appearance="outline" class="w-100">
                              <input matInput name="trustee_Name" [(ngModel)]="trustees.trustee_Name" title="{{trustees.trustee_Name}}" type="text" class="text-left" placeholder="" disabled />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="Office">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">Office (if any)</th>
                          <td mat-cell *matCellDef="let trustees">
                            <mat-form-field appearance="outline" class="w-100">
                              <input matInput name="office" placeholder="Office (if any)" [(ngModel)]="trustees.office" type="text" class="text-left" disabled />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="DateAppointed">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">Date Appointed (Acted if not for whole year)</th>
                          <td mat-cell *matCellDef="let trustees">
                            <mat-form-field appearance="outline" class="w-100" [ngClass]="{'mat-input-error':trustees.rowmsg1}">
                              <input matInput name="datesActed" (blur)="checkdate3($event,trustees)" (dateChange)="checkdate3($event,trustees)" disabled (input)="removevalid3($event,trustees);dirty()" [matDatepicker]="picker20" placeholder="dd/mm/yyyy" class="date-left" appTextMaskDate [(ngModel)]="trustees.datesActed" />
                              <mat-datepicker-toggle matIconSuffix [for]="picker20"></mat-datepicker-toggle>
                              <mat-datepicker #picker20></mat-datepicker>
                            </mat-form-field>
                            <mat-error *ngIf="trustees.rowmsg1" class="p-l-12">
                              {{trustees.rowmsg1}}
                            </mat-error>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="DateResigned">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">Date Resigned (Acted if not for whole year)</th>
                          <td mat-cell *matCellDef="let trustees">
                            <mat-form-field appearance="outline" class="w-100" [class.mat-form-field-invalid]="trustees.rowmsg2">
                              <input matInput name="dateActedResigned" (blur)="checkdate4($event,trustees)" (dateChange)="checkdate4($event,trustees)" (input)="removevalid4($event,trustees);dirty()" [matDatepicker]="picker21" placeholder="dd/mm/yyyy" class="date-left" appTextMaskDate [(ngModel)]="trustees.dateActedResigned" [disabled]="apFinalised" />
                              <mat-datepicker-toggle matIconSuffix [for]="picker21"></mat-datepicker-toggle>
                              <mat-datepicker #picker21></mat-datepicker>
                            </mat-form-field>
                            <mat-error *ngIf="trustees.rowmsg2" class="p-l-12">
                              {{trustees.rowmsg2}}
                            </mat-error>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="Name">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">
                            Name of person (or body) entitled to appoint trustee (if any)
                          </th>
                          <td mat-cell *matCellDef="let trustees">
                            <mat-form-field appearance="outline" class="w-100">
                              <input matInput name="nameofPerson" appTrim maxlength="40" [(ngModel)]="trustees.nameofPerson" (input)="dirty()" type="text" class="text-left" placeholder="Appoint Trustee (if any)" [disabled]="apFinalised" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="example-first-header-row"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                          <td class="mat-cell text-center " [attr.colspan]="displayedColumns.length">
                            <div class="container-fluid bg-light-primary rounded p-20 f-s-14">
                              No records found
                            </div>
                          </td>
                        </tr>
                      </table>
                    </fieldset>
                  </div>
                </div>
              </mat-card-content>
              <mat-card-content class="b-1 m-t-12 p-x-0">
                <mat-card-title class="p-x-14 b-b-1 mat-mdc-card-title">
                  <div class="d-flex align-items-center p-y-20">
                    <div class="">
                      <h4 class="f-s-16 primary-color-dark f-w-600 d-block">
                        Names of other trustees for the charity, if any, (for example, any custodian trustees)
                      </h4>
                    </div>
                  </div>
                </mat-card-title>
                <div class="p-x-14 m-y-10 row">
                  <div class="table-responsive w-100 m-14" style="border-radius: 6px;" *ngIf="otherTrustees?.length>0">
                    <fieldset [disabled]="apFinalised">
                      <table mat-table [dataSource]="otherTrustees" class="w-100">
                        <ng-container matColumnDef="Name">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12"> Trustee Name </th>
                          <td mat-cell *matCellDef="let trustees let i=index" style="max-width: 30% !important; width: 30% !important;">
                            <mat-form-field appearance="outline" class="w-100" [class.mat-form-field-invalid]="showValidation1 && !trustees.trustee_Name">
                              <input name="trustee_Name" matInput appTrim maxlength="40" (input)="dirty()" [(ngModel)]="trustees.trustee_Name" type="text" class="text-left" placeholder="Trustee Name" [disabled]="apFinalised" />
                            </mat-form-field>
                            <mat-error *ngIf="showValidation1 && !trustees.trustee_Name" class="p-x-12">
                              Trustee Name is required
                            </mat-error>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="DateAppointed">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">Date Appointed (Acted if not for whole year)</th>
                          <td mat-cell *matCellDef="let trustees" style="max-width: 25% !important; width: 25% !important;">
                            <mat-form-field appearance="outline" class="w-100" [class.mat-form-field-invalid]="trustees.rowmsg1">
                              <input name="dateActed" matInput (blur)="checkdate1($event,trustees)" (dateChange)="checkdate1($event,trustees)" (input)="removevalid1($event,trustees);dirty()" [matDatepicker]="picker22" class="date-left" placeholder="dd/mm/yyyy" appTextMaskDate [(ngModel)]="trustees.dateActed" [disabled]="apFinalised" />
                              <mat-datepicker-toggle matIconSuffix [for]="picker22"></mat-datepicker-toggle>
                              <mat-datepicker #picker22></mat-datepicker>
                            </mat-form-field>
                            <mat-error *ngIf="trustees.rowmsg1 " class="p-l-12">
                              {{trustees.rowmsg1}}
                            </mat-error>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="DateResigned">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">Date Resigned (Acted if not for whole year)</th>
                          <td mat-cell *matCellDef="let trustees" style="max-width: 25% !important; width: 25% !important;">
                            <mat-form-field appearance="outline" class="w-100" [class.mat-form-field-invalid]="trustees.rowmsg2">
                              <input matInput [matDatepicker]="picker23" (blur)="checkdate2($event,trustees)" (dateChange)="checkdate2($event,trustees)" (input)="removevalid2($event,trustees);dirty()" class="date-left" placeholder="dd/mm/yyyy" name="dateActedResigned" appTextMaskDate [(ngModel)]="trustees.dateActedResigned" [disabled]="apFinalised" />
                              <mat-datepicker-toggle matIconSuffix [for]="picker23"></mat-datepicker-toggle>
                              <mat-datepicker #picker23></mat-datepicker>
                            </mat-form-field>
                            <mat-error *ngIf="trustees.rowmsg2" class="p-l-12">
                              {{trustees.rowmsg2}}
                            </mat-error>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="action" style="max-width: 20% !important; width: 20% !important;">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12 text-center">Action</th>
                          <td mat-cell *matCellDef="let trustees; let i=index" class="text-center">
                            <button mat-flat-button [disabled]="apFinalised" class="bg-none text-center" style="height: 30px;" (click)="DeleteRow(i)" aria-label="Example icon button with a home icon">
                              <i-tabler class="icon-18 m-r-10 text-danger" name="trash"></i-tabler>
                            </button>
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumnsOthertrustees" class="example-first-header-row"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsOthertrustees;"></tr>
                      </table>
                    </fieldset>
                  </div>
                  <fieldset [disabled]="apFinalised">
                    <button mat-flat-button class="add-button m-l-16 m-y-10" style="height: 30px;" (click)="AddRow()" [disabled]="!UserRoleAccess?.m1Add">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add Trustee</span>
                      </div>
                    </button>
                  </fieldset>
                </div>
              </mat-card-content>
              <mat-card-content class="b-1 m-t-12 p-x-0">
                <mat-card-title class="p-x-14 b-b-1 mat-mdc-card-title">
                  <div class="d-flex align-items-center p-y-20">
                    <div class="">
                      <h4 class="f-s-16 primary-color-dark f-w-600 d-block">
                        Names and addresses of advisers (optional information)
                      </h4>
                    </div>
                  </div>
                </mat-card-title>
                <div class="p-x-14 m-y-10 row">
                  <div class="table-responsive w-100 m-14" style="border-radius: 6px;" *ngIf="optionalAdvisers?.length>0">
                    <fieldset [disabled]="apFinalised">
                      <table mat-table [dataSource]="optionalAdvisers" class="w-100">
                        <ng-container matColumnDef="Type of adviser">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">Type of Adviser</th>
                          <td mat-cell *matCellDef="let optionalAdvisers let i=index">
                            <mat-form-field appearance="outline" class="w-100 no-subscript" [class.mat-form-field-invalid]="showValidation2 && !optionalAdvisers.typeOfAdviser">
                              <mat-select [(ngModel)]="optionalAdvisers.typeOfAdviser" (selectionChange)="optionalAdvisers.advisers_Name = '';optionalAdvisers.address='';showValidation16=false;dirty()" class=" text-left" placeholder="Select Adviser Type" [disabled]="apFinalised">
                                <mat-option *ngFor="let data of advisorTypes" [value]="data">{{ data }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-error *ngIf="showValidation2 && !optionalAdvisers.typeOfAdviser" class="p-x-12">
                              Select a Adviser Type
                            </mat-error>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="Name">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12"> Adviser Name</th>
                          <td mat-cell *matCellDef="let optionalAdvisers let i=index">
                            <mat-form-field appearance="outline" class="w-100 no-subscript" [class.mat-form-field-invalid]="showValidation16 && !optionalAdvisers.advisers_Name">
                              <mat-select [(ngModel)]="optionalAdvisers.advisorsId" class=" text-left" placeholder="Select Adviser Name" (selectionChange)="onAdvisorNameChange(optionalAdvisers.typeOfAdviser, optionalAdvisers.advisorsId, i);dirty()" [disabled]="apFinalised">
                                <mat-option *ngFor="let adv of getAdvisorNamesByType(optionalAdvisers.typeOfAdviser)" [value]="adv.advisorsId">{{ adv.professionalAdvisors_Name }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-error *ngIf="showValidation16 && !optionalAdvisers.advisers_Name" class="p-x-12">
                              Select a Adviser Name
                            </mat-error>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="Address">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">Address</th>
                          <td mat-cell *matCellDef="let optionalAdvisers">
                            <mat-form-field appearance="outline" class="w-100">
                              <input name="address" matInput appTrim maxlength="100" [(ngModel)]="optionalAdvisers.address" type="text" class="text-left" disabled placeholder="Address" title="{{optionalAdvisers.address}}" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12 text-center">Action</th>
                          <td mat-cell *matCellDef="let trustees let i=index" class="text-center">
                            <button mat-flat-button [disabled]="apFinalised" class="bg-none text-center" style="height: 30px;" (click)="DeleteRow2(i)" aria-label="Example icon button with a home icon">
                              <i-tabler class="icon-18 m-r-10 text-danger" name="trash"></i-tabler>
                            </button>
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumnsadvisers" class="example-first-header-row"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsadvisers;"></tr>
                      </table>
                    </fieldset>
                  </div>
                  <fieldset [disabled]="apFinalised">
                    <button mat-flat-button class="add-button m-l-16 m-y-10" style="height: 30px;" (click)="AddRow2()" [disabled]="!UserRoleAccess?.m1Add">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add Adviser </span>
                      </div>
                    </button>
                  </fieldset>
                </div>
              </mat-card-content>
              <mat-card-content class="b-1 m-t-12 p-x-0">
                <fieldset [disabled]="apFinalised">
                  <mat-card-title class="p-x-14 b-b-1 mat-mdc-card-title">
                    <div class="d-flex align-items-center p-y-20">
                      <div class="">
                        <h4 class="f-s-16 primary-color-dark f-w-600 d-block">
                          Name of chief executive or names of senior staff members (optional information)
                        </h4>
                      </div>
                    </div>
                  </mat-card-title>
                  <div class="p-x-14 m-y-10 row">
                    <mat-form-field class="example-full-width w-100 m-x-24 mt-16" appearance="outline">
                      <textarea matInput (input)="dirty()" appTrim [(ngModel)]="tarDetails.nameofChiefExecutive" [disabled]="apFinalised" rows="3" class="text-start" placeholder="" maxlength="2500"></textarea>
                    </mat-form-field>
                  </div>
                </fieldset>
              </mat-card-content>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab label="Section B" [disabled]="!isSectionAValid1()||isAnyDateInvalid()">
          <ng-template matTabContent>
            <div class="p-16 b-b-1 justify-content-center align-items-center" style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
              <mat-card-title class="p-x-8 mat-mdc-card-title ">
                <h4 class="f-s-26 f-w-700 text-center" style=" background: #10756e; padding: 10px; color: #fff;"> Objectives and Activities</h4>
              </mat-card-title>
              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px; color: #10756e;">{{ jurisdiction_Charity !== 'england_wales' ? 'Charitable purposes' : 'Summary of the purposes of the charity as set out in its governing document' }}</h4>
              <mat-card-content class="m-t-10 p-x-8">
                <fieldset [disabled]="apFinalised" class="p-x-0">
                  <div class="ck-wrapper" [hidden]="showCropper" style="min-height: 300px;">
                    <editor [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecC" (ngModelChange)="handleEditorInput($event,'description_SecC')" [placeholder]="'Type here...'" [init]="tinyConfig"></editor>
                  </div>
                </fieldset>
              </mat-card-content>
              <h4 class="f-s-16 f-w-500 m-t-0 text-left" style="padding: 10px; color: #10756e;">
                {{jurisdiction_Charity !== 'england_wales' ? 'Summary of the main activities in relation to these objects' : 'Summary of the main activities in relation to those purposes for the public benefit, in particular, the activities, projects or services identified in the accounts' }}
              </h4>
              <mat-card-content class="m-t-10 p-x-8">
                <fieldset [disabled]="apFinalised" class="p-x-0">
                  <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                    <editor [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecC_2" (ngModelChange)="handleEditorInput($event,'description_SecC_2')" [placeholder]="'Type here...'" [init]="tinyConfig"></editor>
                  </div>
                </fieldset>
              </mat-card-content>
              <h4 class="f-s-16 f-w-500 m-t-0 text-left" style="padding: 10px; color: #10756e;" *ngIf="jurisdiction_Charity == 'england_wales'">Statement confirming whether the trustees have had regard to the guidance issued by the Charity Commission on public benefit</h4>
              <mat-card-content class="m-t-10 p-x-8" *ngIf="jurisdiction_Charity == 'england_wales'">
                <fieldset [disabled]="apFinalised" class="p-x-0">
                  <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                    <editor [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecC_3" (ngModelChange)="handleEditorInput($event,'description_SecC_3')" [placeholder]="'Type here...'" [init]="tinyConfig"></editor>
                  </div>
                </fieldset>
              </mat-card-content>
              <h4 class="f-s-16 f-w-500 m-t-0 text-left" style="padding: 10px; color: #10756e;" *ngIf="jurisdiction_Charity == 'england_wales'">Additional Information </h4>
              <mat-card-content class="m-t-10 p-x-8" *ngIf="jurisdiction_Charity == 'england_wales'">
                <fieldset [disabled]="apFinalised" class="p-x-0">
                  <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                    <editor [(ngModel)]="tarDetails.description_SecC_4" (ngModelChange)="handleEditorInput($event,'description_SecC_4')" [placeholder]="'Type here...'" [init]="tinyConfig"></editor>
                  </div>
                </fieldset>
              </mat-card-content>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab label="Section C" [disabled]="!isSectionAValid1()||isAnyDateInvalid()">
          <ng-template matTabContent>
            <div class="p-16 b-b-1 justify-content-center align-items-center" style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
              <mat-card-title class="p-x-8 mat-mdc-card-title ">
                <h4 class="f-s-26 f-w-700 text-center" style=" background: #10756e; padding: 10px; color: #fff;"> Achievements and Performance</h4>
              </mat-card-title>
              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px; color: #10756e;">
                {{jurisdiction_Charity !== 'england_wales' ? 'Summary of the main achievements of the charity during the financial period	' : 'Summary of the main achievements of the charity, identifying the difference the charity’s work has made to the circumstances of its beneficiaries and any wider benefits to society as a whole'}}
              </h4>
              <mat-card-content class="m-t-10 p-x-8">
                <fieldset [disabled]="apFinalised" class="p-x-0">
                  <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                    <editor [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecD" (ngModelChange)="handleEditorInput($event,'description_SecD')" [placeholder]="'Type here...'" [init]="tinyConfig"></editor>
                  </div>
                </fieldset>
              </mat-card-content>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab label="Section D" [disabled]="!isSectionAValid1()||isAnyDateInvalid()">
          <ng-template matTabContent>
            <div class="p-16 b-b-1  justify-content-center align-items-center" style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
              <mat-card-title class="p-x-8 mat-mdc-card-title ">
                <h4 class="f-s-26 f-w-700 text-center" style=" background: #10756e; padding: 10px; color: #fff;"> Financial Review</h4>
              </mat-card-title>
              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px; color: #10756e;" *ngIf="jurisdiction_Charity == 'england_wales'">Review of the charity’s financial position at the end of the period</h4>
              <mat-card-content class="m-t-10 p-x-8" *ngIf="jurisdiction_Charity == 'england_wales'">
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <fieldset [disabled]="apFinalised" class="p-x-0">
                    <editor [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecE" (ngModelChange)="handleEditorInput($event,'description_SecE')" [placeholder]="'Type here...'" [init]="tinyConfig"></editor>
                  </fieldset>
                </div>
              </mat-card-content>
              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px; color: #10756e;">
                {{jurisdiction_Charity !== 'england_wales' ? 'Statement of the charity’s policy on reserves' : 'Statement explaining the policy for holding reserves stating why they are held'}}
              </h4>
              <mat-card-content class="m-t-10 p-x-8">
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <fieldset [disabled]="apFinalised" class="p-x-0">
                    <editor [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecE_2" (ngModelChange)="handleEditorInput($event,'description_SecE_2')" [placeholder]="'Type here...'" [init]="tinyConfig"></editor>
                  </fieldset>
                </div>
              </mat-card-content>
              <div class="col-12 p-r-8 p-l-0" *ngIf="jurisdiction_Charity == 'england_wales'">
                <div class="row align-items-center m-t-20 m-b-8">
                  <div class="col-lg-6">
                    <h4 class="f-s-16 f-w-500 text-left" style="padding: 10px; color: #10756e;">Amount of reserves held (£)</h4>
                  </div>
                  <div class="col-lg-6">
                    <fieldset [disabled]="apFinalised" class="p-x-0">
                      <mat-form-field appearance="outline" class="hide-hint w-100">
                        <input matInput type="text" [(ngModel)]="tarDetails.description_SecE_3" (input)="onDecimalInput($event, 'description_SecE_3')" class="text-right" (keydown)="blockSymbols($event)" (paste)="blockPaste($event)" />
                      </mat-form-field>
                    </fieldset>
                  </div>
                </div>
              </div>
              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px; color: #10756e;" *ngIf="jurisdiction_Charity == 'england_wales'">Reasons for holding zero reserves </h4>
              <mat-card-content class="m-t-10 p-x-8" *ngIf="jurisdiction_Charity == 'england_wales'">
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <fieldset [disabled]="apFinalised" class="p-x-0">
                    <editor [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecE_4" (ngModelChange)="handleEditorInput($event,'description_SecE_4')" [placeholder]="'Type here...'" [init]="tinyConfig"></editor>
                  </fieldset>
                </div>
              </mat-card-content>
              <div class="col-12 p-r-8 p-l-0">
                <div class="row align-items-center m-t-20 m-b-8">
                  <div class="col-lg-6">
                    <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px; color: #10756e;">
                      {{jurisdiction_Charity !== 'england_wales' ? 'Details of any deficit' : 'Details of fund materially in deficit (£)'}}
                    </h4>
                  </div>
                  <div class="col-lg-6">
                    <fieldset [disabled]="apFinalised" class="p-x-0">
                      <mat-form-field appearance="outline" class="hide-hint w-100">
                        <input matInput type="text" [(ngModel)]="tarDetails.description_SecE_5" (input)="onDecimalInput($event, 'description_SecE_5')" class="text-right" (keydown)="blockSymbols($event)" (paste)="blockPaste($event)" />
                      </mat-form-field>
                    </fieldset>
                  </div>
                </div>
              </div>
              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px; color: #10756e;" *ngIf="jurisdiction_Charity == 'england_wales'">Explanation of any uncertainties about the charity continuing as a going concern</h4>
              <mat-card-content class="m-t-10 p-x-8" *ngIf="jurisdiction_Charity == 'england_wales'">
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <fieldset [disabled]="apFinalised" class="p-x-0">
                    <editor [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecE_6" (ngModelChange)="handleEditorInput($event,'description_SecE_6')" [placeholder]="'Type here...'" [init]="tinyConfig"></editor>
                  </fieldset>
                </div>
              </mat-card-content>
              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px; color: #10756e;" *ngIf="jurisdiction_Charity !== 'england_wales'">Donated facilities and services (if any) </h4>
              <mat-card-content class="m-t-10 p-x-8" *ngIf="jurisdiction_Charity !== 'england_wales'">
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <fieldset [disabled]="apFinalised" class="p-x-0">
                    <editor [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecE_S7" (ngModelChange)="handleEditorInput($event,'description_SecE_S7')" [placeholder]="'Type here...'" [init]="tinyConfig"></editor>
                  </fieldset>
                </div>
              </mat-card-content>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab label="Section E" [disabled]="!isSectionAValid1()||isAnyDateInvalid()">
          <ng-template matTabContent>
            <div class="p-16 b-b-1 justify-content-center align-items-center" style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
              <mat-card-title class="p-x-0 mat-mdc-card-title ">
                <h4 class="f-s-26 f-w-700 text-center" style=" background: #10756e; padding: 10px; color: #fff;"> Structure, Governance and Management</h4>
              </mat-card-title>
              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px 0px ; color: #10756e;">Type of governing document   </h4>
              <mat-card-content class="m-t-10 p-x-0">
                <fieldset [disabled]="apFinalised" class="p-x-0">
                  <div class="NgxEditor__Wrapper" style="min-height: 220px;">
                    <editor [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecB" (ngModelChange)="handleEditorInput($event,'description_SecB')" [placeholder]="'Type here...'" [init]="tinyConfig"></editor>
                  </div>
                </fieldset>
              </mat-card-content>
              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px 0px; color: #10756e;">
                {{jurisdiction_Charity !== 'england_wales' ? 'Trustee recruitment and appointment' : 'Trustee selection methods including details of any constitutional provisions e.g. election to post or name of any person or body entitled to appoint one or more trustees'}}
              </h4>
              <mat-card-content class="m-t-10 p-x-0">
                <fieldset [disabled]="apFinalised" class="p-x-0">
                  <div class="NgxEditor__Wrapper" style="min-height: 220px;">
                    <editor [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecB_2" (ngModelChange)="handleEditorInput($event,'description_SecB_2')" [placeholder]="'Type here...'" [init]="tinyConfig"></editor>
                  </div>
                </fieldset>
              </mat-card-content>
              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px 0px; color: #10756e;" *ngIf="jurisdiction_Charity == 'england_wales'">Additional information</h4>
              <mat-card-content class="m-t-10 p-x-0" *ngIf="jurisdiction_Charity == 'england_wales'">
                <fieldset [disabled]="apFinalised" class="p-x-0">
                  <div class="NgxEditor__Wrapper" style="min-height: 220px;">
                    <editor [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecB_3" (ngModelChange)="handleEditorInput($event,'description_SecB_3')" [placeholder]="'Type here...'" [init]="tinyConfig"></editor>
                  </div>
                </fieldset>
              </mat-card-content>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab label="Section F" [disabled]="!isSectionAValid1()||isAnyDateInvalid()" *ngIf="jurisdiction_Charity !== 'england_wales'">
          <ng-template matTabContent>
            <div class="p-16 b-b-1 justify-content-center align-items-center" style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
              <mat-card-title class="p-x-8 mat-mdc-card-title ">
                <h4 class="f-s-26 f-w-700 text-center" style=" background: #10756e; padding: 10px; color: #fff;"> Other optional information</h4>
              </mat-card-title>
              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px; color: #10756e;">Additional information</h4>
              <mat-card-content class="m-t-10 p-x-8">
                <fieldset [disabled]="apFinalised" class="p-x-0">
                  <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                    <editor [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecFS" (ngModelChange)="handleEditorInput($event,'description_SecFS')" [placeholder]="'Type here...'" [init]="tinyConfig"></editor>
                  </div>
                </fieldset>
              </mat-card-content>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </mat-card>
  </div>
  <hr class="m-t-24" style="opacity:0.2" *ngIf="tarDetails.annualReport_Status!='No'" />
  <div class="row p-16 m-b-8">
    <div class="col-6 col-sm-6 col-md-4">
      <button mat-flat-button class="bg-warning text-end" (click)="goToPreviousTab()">
        <div class="d-flex text-black">
          <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black hidemenutext"> Back</span>
        </div>
      </button>
    </div>
    <div class="col-6 col-sm-6 col-md-8" align="right">
      <button mat-flat-button type="submit" class="bg-success rounded-5" (click)="goToNextTab('yes')" *ngIf="tarDetails.annualReport_Status!='No'">
        <div class="d-flex">
          <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-right"></i-tabler><span class="f-s-14 text-dark hidemenutext"> Next</span>
        </div>
      </button>
      <button mat-flat-button type="submit" class="bg-success rounded-5" (click)="goToNextTab('no')" *ngIf="tarDetails.annualReport_Status=='No'">
        <div class="d-flex">
          <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-right"></i-tabler><span class="f-s-14 text-dark hidemenutext"> Next</span>
        </div>
      </button>
    </div>
  </div>
</div>
<div class="m-t-12 StatementofRes" *ngIf="StatementofRes">
  <div class="col-12 p-0 m-t-12">
    <div class="col-sm-12 col-sm-12 bg-white border-radius10 m-b-10 p-10 p-x-16">
      <div class="d-flex justify-content-between align-items-center">
        <div class="label">
          <p class="f-s-14 m-b-10 m-t-6">The trustees are responsible for providing stakeholders with accurate information regarding the charity’s activities, achievements, and governance.</p>
          <h4 class="f-s-14">Do you want to include Statement of Trustees’ Responsibility in your Accounts?</h4>
        </div>
        <div class="radio-selection">
          <mat-radio-group aria-label="Select an option" (change)="setVisibility1($event)" [(ngModel)]="statementofTrusteesModal.includeTAR" [disabled]="apFinalised">
            <mat-radio-button value='Yes' [checked]="showContent1">Yes</mat-radio-button>
            <mat-radio-button value='No' [checked]="!showContent1">No</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
  </div>
  <mat-card *ngIf="statementofTrusteesModal.includeTAR=='Yes'">
    <fieldset [disabled]="apFinalised" class="p-0">
      <mat-card-content class="p-0">
        <div style="max-height: 460px; overflow-y: auto; overflow-x: hidden">
          <div>
            <mat-card-content class="p-0 bg-white" style="border-radius: 12px;">
              <div class="p-16 p-b-0 justify-content-center align-items-center">
                <!-- Rich Text Editor -->
                <mat-card-content class="bg-white m-t-0 p-x-0 p-t-0">
                  <div class="p-b-10 d-flex justify-content-end">
                    <button mat-flat-button (click)="SetDefault()" class="bg-none text-primary" style="height: 30px;" [disabled]="!UserRoleAccess?.m1Create">
                      <span class=""> Default Statement </span>
                    </button>
                  </div>
                  <div class="NgxEditor__Wrapper" style="min-height: 220px;">
                    <editor [disabled]="apFinalised" [disabled]="apFinalised" [(ngModel)]="statementofTrusteesModal.trusteeStatement" (ngModelChange)="handleEditorInput($event,'trusteeStatement')" [placeholder]="'Type here...'" [init]="tinyConfig"></editor>
                  </div>
                </mat-card-content>
              </div>
            </mat-card-content>
          </div>
        </div>
      </mat-card-content>
    </fieldset>
  </mat-card>
  <hr class="m-t-16" style="opacity:0.2" *ngIf="statementofTrusteesModal.includeTAR=='Yes'" />
  <div class="row p-16 p-b-0 m-b-0">
    <div class="col-6 col-sm-6 col-md-4 m-b-16">
      <button mat-flat-button class="bg-warning text-end" (click)="showTrusteeRepport()">
        <div class="d-flex text-black">
          <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black hidemenutext"> Back</span>
        </div>
      </button>
    </div>
    <div class="col-6 col-sm-6 col-md-8 m-b-16" align="right">
      <button mat-flat-button class="bg-success rounded-5" (click)="showDeclaration()" [disabled]="!UserRoleAccess?.m1View">
        <div class="d-flex">
          <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-right"></i-tabler><span class="f-s-14 text-dark hidemenutext">Next</span>
        </div>
      </button>
    </div>
  </div>
</div>
<div class="m-t-12 declaration" *ngIf="declaration">
  <mat-card>
    <mat-card-content class="p-0 p-b-12">
      <fieldset [disabled]="apFinalised || isDeclarationDisabled()">
        <div class="col-12">
          <mat-card-content class="b-1 m-t-12 p-0">
            <mat-card-title class="p-x-14 b-b-1 mat-mdc-card-title" style="background: #e6f1f0;">
              <div class="d-flex align-items-center p-y-20">
                <div class="icon-holder">
                  <i-tabler class="icon-24 m-r-0 primary-color-dark" name="circle-check"></i-tabler>
                </div>
                <div class="">
                  <h4 class="f-s-16 primary-color-dark f-w-600 d-block">Trustee Declaration</h4>
                  <p class="f-s-14 m-0">Approve and sign the report on behalf of the board of trustees.</p>
                </div>
              </div>
            </mat-card-title>
            <div class="p-x-14 m-y-10 row">
              <div class="col-lg-6">
                <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                  <div class="d-flex align-items-center">
                    <i-tabler class="icon-24 m-r-10 primary-color-dark" name="user"></i-tabler>
                    <h5 class="f-w-600 f-s-14">
                      Approved by Trustee <span class="text-error">*</span>
                    </h5>
                  </div>
                </mat-label>
                <!--<mat-form-field appearance="outline" class="w-100" [class.mat-form-field-invalid]="showValidation3 && !tarDetails.approvedbyTrustee_SecA" style="height:40px !important;">
    <mat-select (selectionChange)="dirty()" [(ngModel)]="tarDetails.approvedbyTrustee_SecA" placeholder="Select Trustee" [disabled]="apFinalised ||isDeclarationDisabled()">
      <mat-option *ngFor="let data of trustees" [value]="data.truste_Id">{{ data.trustee_Name
                }}</mat-option>
                </mat-select>
                </mat-form-field>
                <mat-error *ngIf="showValidation3 && !tarDetails.approvedbyTrustee_SecA" class="p-x-12">
                  Select a Trustee
                </mat-error>-->

                <mat-form-field appearance="outline" class="w-100" [class.mat-form-field-invalid]="showValidation3 && !tarDetails.approvedbyTrustee_SecA" style="height:40px !important;">
                  <mat-select (selectionChange)="onTrusteeChange($event,'selected')" [(ngModel)]="tarDetails.approvedbyTrustee_SecA" placeholder="Select Trustee" [disabled]="apFinalised ||isDeclarationDisabled()">
                    <mat-option (click)="modalAddAdvisor(template)" *ngIf="this.trustees" class="lightBtn">
                      <div class="d-flex thmeColor"><i-tabler class="icon-18 m-r-4" name="plus"></i-tabler><span class="hidemenutext">  Trustee</span></div>
                    </mat-option>
                    <mat-option *ngFor="let data of trustees" [value]="data.truste_Id">
                      {{ data.trustee_Name }}
                    </mat-option>
                  </mat-select>

                  <!--<mat-error *ngIf="(form.get('trustee_Name')?.getRawValue() ==''||form.get('trustee_Name')?.getRawValue() ==null) && form.get('trustee_Name')?.touched">
      Select a Trustee
    </mat-error>-->
                </mat-form-field>
                <mat-error *ngIf="showValidation3 && !tarDetails.approvedbyTrustee_SecA" class="p-x-12">
                  Select a Trustee
                </mat-error>
</div>
              <div class="col-lg-6">
                <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                  <div class="d-flex align-items-center">
                    <i-tabler class="icon-24 m-r-10 primary-color-dark" name="calendar"></i-tabler>
                    <h5 class="f-w-600 f-s-14">
                      Approval Date <span class="text-error">*</span>
                    </h5>
                  </div>
                </mat-label>
                <mat-form-field appearance="outline" class="w-100" [class.mat-form-field-invalid]="(showValidation4 && !tarDetails.approvalDate_SecA)||tarDetails.rowmsg">
                  <input matInput [disabled]="apFinalised ||isDeclarationDisabled()" (blur)="checkdate($event,tarDetails)" (dateChange)="checkdate($event,tarDetails)" (input)="removevalid($event,tarDetails);dirty()" [matDatepicker]="picker3" class="date-left" placeholder="dd/mm/yyyy" appTextMaskDate [(ngModel)]="tarDetails.approvalDate_SecA" />
                  <mat-datepicker-toggle matIconSuffix [for]="picker3"></mat-datepicker-toggle>
                  <mat-datepicker #picker3></mat-datepicker>
                </mat-form-field>
                <mat-error *ngIf="tarDetails.rowmsg" class="p-l-12">
                  {{tarDetails.rowmsg}}
                </mat-error>
                <mat-error *ngIf="showValidation4 && !tarDetails.approvalDate_SecA && !tarDetails.rowmsg" class="p-x-12">
                  Approval Date is required
                </mat-error>
              </div>
              <!--show below section dynamic while choosing Trustee-->
              <div class="col-lg-12 d-none">
                <div class="rounded-2 b-1 p-14 m-y-6" style="border-radius: 6px; background: #e6f1f0;">
                  <p class="f-s-14 primary-color-dark">
                    The Trustees' annual report was approved on {{tarDetails.approvalDate_SecA}} and signed on behalf of the board of trustees by: {{tarDetails.approvedbyTrustee_SecA}}
                  </p>
                </div>
              </div>
            </div>
          </mat-card-content>
        </div>
      </fieldset>
    </mat-card-content>
  </mat-card>
  <hr class="m-t-24" style="opacity:0.2" />
  <div class="row p-16">
    <div class="col-6 col-sm-6 col-md-4 m-b-16">
      <button mat-flat-button class="bg-warning text-end" (click)="showStatementofRes()">
        <div class="d-flex text-black">
          <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black hidemenutext"> Back</span>
        </div>
      </button>
    </div>
    <div class="col-6 col-sm-6 col-md-8 m-b-16" align="right">
      <button mat-flat-button class="bg-success rounded-5" (click)="SaveTar()" [disabled]="!UserRoleAccess?.m1View">
        <div class="d-flex">
          <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-right"></i-tabler><span class="f-s-14 text-dark hidemenutext">Next</span>
        </div>
      </button>
    </div>
  </div>
</div>

<ng-template #template>
  <div class="bg-light p-y-14 p-x-24">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <mat-card-title class="mat-mdc-card-title d-flex gap-10 align-items-center">
          <h4 class="f-s-26 f-w-700" style="white-space:nowrap;">{{ edithead ? 'Edit Professional Adviser' : 'Add New Trustee' }}</h4>
        </mat-card-title>
      </div>
      <div>

        <button class="d-flex justify-content-center  btn-close-dialog" (click)="closeTrustee()">
          <i-tabler name="X" class="icon-20 m-r-2"></i-tabler>
        </button>
      </div>
    </div>
  </div>

  <form [formGroup]="CharityTrusteesFrom" class="p-x-10" validateOnTouch>
    <div class="m-y-20">
      <div class="col-md-12 col-lg-12">
        <div class="row">
          <div class="col-sm-12 d-flex align-items-center">
            <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Trustee Name <span class="text-danger"> *</span></mat-label>
          </div>
          <div class="col-sm-12">
            <!--<p class="text-black f-s-14" style="word-break: break-word;">{{trusteeName}}</p>-->
          </div>
          <div class="col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <input matInput placeholder="Trustee Name" appInputRestriction='CompanyName' appTrim formControlName="name" maxlength="50" />
              <mat-error class="aligin-items f-s-14" *ngIf="CharityTrusteesFrom.get('name')?.hasError('required') ">
                Trustee Name is required
              </mat-error>
            </mat-form-field>

          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-12">
        <div class="row p-t-20">
          <div class="col-sm-12 d-flex align-items-center">
            <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Date of Appointment <span class="text-danger"> *</span></mat-label>
          </div>
          <div class="col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <input matInput [matDatepicker]="picker" appTextMaskDate placeholder="dd/mm/yyyy" formControlName="date_of_appointment" (blur)="vldtrusteedateofapp($event)" (dateChange)="vldtrusteedateofapp($event)" />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error class="aligin-items f-s-14" *ngIf="CharityTrusteesFrom.get('date_of_appointment')?.hasError('required') ">
                Date of Appointment is required
              </mat-error>
              <mat-error class="aligin-items f-s-14" *ngIf="CharityTrusteesFrom.get('date_of_appointment')?.hasError('invalid') ">
                Date of Appointment is invalid
              </mat-error>
              <mat-error class="aligin-items f-s-14" *ngIf="CharityTrusteesFrom.get('date_of_appointment')?.hasError('date') ">
                Date of Appointment cannot be later than Today
              </mat-error>
              <mat-error class="f-s-14" *ngIf="CharityTrusteesFrom.get('date_of_appointment')?.hasError('Removaldate') ">
                Date of Appointment cannot be more than Charity Removal Date
              </mat-error>
              <mat-error class="f-s-14" *ngIf="CharityTrusteesFrom.get('date_of_appointment')?.hasError('Registrationdate') ">
                Date of Appointment cannot be less than Charity Registration Date
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-12">
        <div class="row p-t-20">
          <section class="example-section">
            <mat-checkbox class="example-margin p-l-4 p-r-0" (change)="showChairOfBoard()" formControlName="is_chair">Chair of the Board</mat-checkbox>
          </section>
        </div>
      </div>

      <div class="m-t-0" *ngIf="chairOfBoardOptions">
        <div class="col-md-12 col-lg-12">
          <div class="row p-t-20">
            <div class="col-sm-12 d-flex align-items-center">
              <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Charity Name <span class="text-danger"> *</span></mat-label>
            </div>
            <div class="col-sm-12">
              <mat-form-field appearance="outline" class="w-100">
                <input matInput placeholder="Charity Name" appInputRestriction='CompanyName' appTrim formControlName="charity_name"  maxlength="160"/>
                <mat-error class="f-s-14" *ngIf=" CharityTrusteesFrom.get('charity_name').hasError('required') && CharityTrusteesFrom.get('charity_name').invalid">
                  Charity Name is required
                </mat-error>
                <mat-error class="f-s-14" *ngIf="CharityTrusteesFrom.get('charity_name').touched && CharityTrusteesFrom.get('charity_name').hasError('pattern')">
                  Only alphanumeric characters allowed
                </mat-error>
                <mat-error class="f-s-14" *ngIf=" CharityTrusteesFrom.get('charity_name').hasError('minlength')">
                  Charity Name  should be minimum 3 characters
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-12">
          <div class="row p-t-20">
            <div class="col-sm-12 d-flex align-items-center">
              <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Charity Number <span class="text-danger"> *</span></mat-label>
            </div>
            <div class="col-sm-12">
              <mat-form-field appearance="outline" class="w-100">
                <input matInput placeholder="Charity Number" appInputRestriction="numericOnly" maxlength="8" (keypress)="restrictInput($event)" formControlName="reg_charity_number" (input)="validateNew($event)" />
                <mat-error class="f-s-14" *ngIf="CharityTrusteesFrom.get('reg_charity_number').invalid && CharityTrusteesFrom.get('reg_charity_number').hasError('required')">
                  Charity Number is required
                </mat-error>
                <mat-error class="f-s-14" *ngIf="CharityTrusteesFrom.get('reg_charity_number').hasError('duplicate') && CharityTrusteesFrom.get('reg_charity_number').invalid">
                  Charity Number already exists
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-12">
          <div class="row p-t-20">
            <div class="col-sm-12 d-flex align-items-center">
              <mat-label class="f-s-14 f-w-600 d-block m-b-0 heading">Reporting Status <span class="text-danger"> *</span></mat-label>
            </div>
            <div class="col-sm-12">
              <mat-form-field appearance="outline" class="w-100 m-t-8">
                <mat-select placeholder="Select Reporting Status" formControlName="reporting_status">
                  <mat-option value="New">New</mat-option>
                  <mat-option value="Removed">Removed</mat-option>
                  <mat-option value="Submission Double Default">Submission Double Default</mat-option>
                  <mat-option value="Submission Overdue">Submission Overdue</mat-option>
                  <mat-option value="Submission Received">Submission Received</mat-option>
                  <mat-option value="Submission Received Late">Submission Received Late</mat-option>
                  <mat-option value="Suppressed">Suppressed</mat-option>
                </mat-select>
                <mat-error class="f-s-14" *ngIf="CharityTrusteesFrom.get('reporting_status')?.hasError('required') ">
                  Select a Reporting Status
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="justify-content-end text-right d-flex p-x-0 bg-light p-y-14 p-x-24">
    <button mat-flat-button class="bg-info m-r-10" (click)="saveTrustee(undefined,'true')" [disabled]="!UserRoleAccess?.m1Edit">
      <div class="d-flex align-items-center border-radius-0 ">
        <span class="f-s-14">Save</span>
      </div>
    </button>

    <button mat-flat-button class="bg-error" (click)=" closeTrustee()">
      <div class="d-flex align-items-center border-radius-0">
        <span class="f-s-14">Cancel</span>
      </div>
    </button>
  </div>
  <div class="spinner-container" *ngIf="ShowSpinner">
    <img src="../../../../assets/images/backgrounds/acct-loading2.gif" />
  </div>
</ng-template>


<div class="spinner-container" *ngIf="ShowSpinner">
  <img src="../../../../assets/images/backgrounds/acct-loading2.gif" />
</div>
